function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function LastPageIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M15 12.1265L6.20508 20.2529L4.84766 18.7842L12.0527 12.1265L4.84766 5.46875L6.20508 4L15 12.1265Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M19 4H17V20.25H19V4Z",
    fill: "currentColor"
  }));
}
export function LastPageIconSmall(props) {
  return ___EmotionJSX(LastPageIcon, _extends({
    size: "small"
  }, props));
}